// extracted by mini-css-extract-plugin
export default {"cardBorder":"ChoiseCard_cardBorder__7L1K9","cardContent":"ChoiseCard_cardContent__FTZJ9","selected":"ChoiseCard_selected__ToaY-"};